import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useAriaLiveContext from "./useAriaLiveContext";

const propTypes = {
	ariaLive: PropTypes.oneOf(['assertive', 'polite']).isRequired,
	messages: PropTypes.arrayOf(PropTypes.node).isRequired,
	numberDivs: PropTypes.number.isRequired,
};
const defaultProps = {};

const setupDefaultLists = numberOfLists => Array.from({ length: numberOfLists }).map(() => []);

const AriaLiveMessages = ({ ariaLive, messages, numberDivs }) => {
	const [messagesLists, setMessagesLists] = useState(() => setupDefaultLists(numberDivs));

	// divide out messages in to equally chunked lists
	useEffect(() => {
		setMessagesLists(messages.reduce((lists, message, i) => {
			lists[i % numberDivs].push(message);
			return lists;
		}, setupDefaultLists(numberDivs)));
	}, [messages]);

	return (
		<>
			{
				messagesLists.map((messagesList, i) => (
					<div aria-live={ariaLive} key={`${ariaLive}-messages-${i}`} role="alert">
						{
							messagesList.length
								? (
									messagesList[messagesList.length - 1]
								)
								: undefined
						}
					</div>
				))
			}
		</>
	);
};

AriaLiveMessages.propTypes = propTypes;
AriaLiveMessages.defaultProps = defaultProps;

export default AriaLiveMessages;
